import { Module } from '../../../Module';
import { GetSiteNamesAcrossAllPodsRequest, IGetSiteNamesAcrossAllPodsResult } from '../../../ServerApi/requests/GetSiteNamesAcrossAllPodsRequest';
import { ISiteNameSansId } from '../../../ServerApi/types/ISiteNameSansId';
import { FetcherFactory } from '../../../services/FetcherFactory';
import { Resource } from '../../../resources/Resource';
import { WebClientListResourceFetcher } from '~commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';

export class SiteNameSansIds extends Resource<ISiteNameSansId> {

  public static readonly instance = new SiteNameSansIds(new WebClientListResourceFetcher(GetSiteNamesAcrossAllPodsRequest, (result: IGetSiteNamesAcrossAllPodsResult) => {
    return result.siteNames;
  }));

}
